import React from "react";

// Official Certified Wellness logo (client-provided file — do NOT recreate in code).
// Served from our own backend so the site has zero third-party-CDN dependencies.
const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/images/z4d6lqsv_CW_LOGO_FIXED.png`;

const Logo = ({ size = 56, inverted = false, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Certified Wellness"
    width={size}
    height={size}
    className={`shrink-0 object-contain select-none ${className}`}
    style={{
      width: size,
      height: size,
      // Black-on-transparent logo → invert to white for dark backgrounds.
      filter: inverted ? "invert(1) brightness(1.05)" : "none",
    }}
    draggable={false}
  />
);

export default Logo;
